import React, { Component } from "react";
import { Card, Row, Col } from "antd";
import { Fragment } from "react";
import "./ClaimsDetail.css";

export default class PaymentDetailsTable extends Component {
  render() {
    return (
      <Fragment>
        <Row className="py-2 services-header">
          <Col span={1} className="pt-2 pl-2">
            #
          </Col>
          <Col span={2} className="pt-2">
            Procedure Date
          </Col>
          <Col span={2} className="pt-2">
            Procedure Code
          </Col>
          <Col span={2} className="px-2 servicesForMediumScreen">
            Oval Cavity Area
          </Col>
          <Col span={1} className="claimsServiceLines px-1">
            Tooth No.
          </Col>
          <Col span={1} className="claimsServiceLines">
            Tooth System
          </Col>
          <Col span={3} className="px-2" style={{textAlign: "center"}}>
            <div>Tooth Surface</div>
            <Row>
              <Col span={5}>
                A
              </Col>
              <Col span={5}>
                B
              </Col>
              <Col span={5}>
                C
              </Col>
              <Col span={5}>D</Col>
              <Col span={4}>E</Col>
            </Row>
          </Col>

          <Col span={3} className="px-2" style={{textAlign: "center"}}>
            <span>Diagnosis Points</span>
            <Row>
              <Col span={6} className="">
                A
              </Col>
              <Col span={6} className="">
                B
              </Col>
              <Col span={6} className="">
                C
              </Col>
              <Col span={6}>D</Col>
            </Row>
          </Col>
          <Col span={1} className="pt-2">
            QTY
          </Col>
          <Col span={2} className="pt-2">
            Fee
          </Col>
          <Col span={2} className="claimsServiceLines">Adjudication Status</Col>
          <Col span={2} className="pt-2">
            Status
          </Col>
          <Col span={2} className="pt-2">
            Action
          </Col>
        </Row>
      </Fragment>
    );
  }
}
